/**
 * Milton Lloyd – Product Card enhancements (ES6)
 */

(() => {
  'use strict';

  if (!document.querySelector('.collection--ml')) return;

  const {
    addToCart = 'Add to cart',
    adding = 'Adding…',
    added = 'Added!',
  } = window.theme?.strings || {};

  const initCard = (card) => {
    if (card.dataset.mlEnhanced) return;
    card.dataset.mlEnhanced = '1';

    // ── Variant select ──────────────────────────────────────────────
    const select = card.querySelector('[data-ml-variant-select]');

    if (select) {
      select.addEventListener('change', (e) => {
        const selectedOption = e.target.selectedOptions[0];
        const variantUrl = selectedOption?.dataset.variantUrl;

        if (!variantUrl) return;

        // Update all product links
        card.querySelectorAll('[data-product-link]').forEach((link) => {
          link.href = variantUrl;
        });

        // Update ATC button variant ID
        card.querySelectorAll('[data-ml-atc]').forEach((btn) => {
          btn.dataset.variantId = e.target.value;
        });
      });
    }

    // ── Add to Cart button ──────────────────────────────────────────
    const atcBtns = card.querySelectorAll('[data-ml-atc]');
    if (!atcBtns.length) return;

    atcBtns.forEach((atcBtn) => {
      atcBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const { variantId } = atcBtn.dataset;
      if (!variantId || atcBtn.disabled) return;

      const span = atcBtn.querySelector('span') || atcBtn;
      const originalText = span.textContent;

      atcBtn.disabled = true;
      span.textContent = adding;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        const cartData = await res.json();

        span.textContent = added;

        // Fire theme:cart:refresh
        document.dispatchEvent(
          new CustomEvent('theme:cart:refresh', { bubbles: true })
        );

        // Fire pub/sub cart update
        if (window.theme?.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          window.publish(window.theme.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ml-product-card',
            productVariantId: variantId,
            cartData,
          });
        }

        setTimeout(() => {
          span.textContent = originalText;
          atcBtn.disabled = false;
        }, 1500);
      } catch (err) {
        span.textContent = 'Error – try again';

        setTimeout(() => {
          span.textContent = originalText;
          atcBtn.disabled = false;
        }, 2000);
      }
      });
    }); // end atcBtns.forEach
  };

  const initAll = () => {
    document
      .querySelectorAll('.collection--ml .grid-item[data-grid-item]')
      .forEach(initCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('ajaxinate:appended', initAll);
})();